<template>
    <ChannelBackendEntityAssociationCmp 
        :association-service="associationService"
        :entity-plural="entityPlural" 
        :one-to-one="true" /> 
</template>

<script>
import ChannelBackendEntityAssociationCmp from '@/utils/components/ChannelBackendEntityAssociationCmp'
import categoryService from '@/category/services/CategoryService'

export default {
    name: 'ChannelCategoryListAssociationView',
    components: {
        ChannelBackendEntityAssociationCmp,
    },
    data() {
        return {
            associationService: categoryService,
            entityPlural: "categorias",
        }
    },
}
</script>